import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {SHARE_MEDIA_SERVICE_SERVICES_MINIMUM_USER_LEVEL} from '../constants';

export const canMangeMediaServiceServices = () =>
	currentUserMeetsUserLevel(SHARE_MEDIA_SERVICE_SERVICES_MINIMUM_USER_LEVEL);
